import Snappy from '../../../libs/snappy/snappy';
import $ from 'jquery';
import App from 'resizement/scripts/resize';

Snappy.Component.EduUnsaveDataObserver = class EduUnsaveDataObserver extends Snappy.BaseComponent {
    static get tagName() {
        return 'edu-unsaved-data-observer';
    }

    constructor(element) {
        super(element);
    }

    render() {
        this.setVars();
        this.setEventListeners();
    }

    setVars() {
        this.unsavedData = null;
        this.unsavedDataWarnMessage =
            'There are unsaved changes on this page. Are you sure you want to leave?';
    }

    setEventListeners() {
        $(window).on('unsaved:changed', this.onUnsavedChanged.bind(this));
    }

    setOnBeforeUnload(nameSpace) {
        this.unsavedData = this.getUnsavedData(nameSpace);

        if (this.unsavedData) {
            let unsavedDataStatuses = [];

            Object.keys(this.unsavedData).forEach(key => {
                unsavedDataStatuses.push(this.unsavedData[key]);
            });

            if (unsavedDataStatuses.some(status => status === true)) {
                window.onbeforeunload = () => this.unsavedDataWarnMessage;
            } else {
                window.onbeforeunload = null;
            }
        }
    }

    getUnsavedData(nameSpace) {
        return JSON.parse(localStorage.getItem(nameSpace));
    }

    onUnsavedChanged(e, nameSpace, data) {
        this.unsavedData = this.getUnsavedData(nameSpace) || {};
        this.unsavedData['unsavedDataWarnMessage'] = this.unsavedDataWarnMessage;

        let mergedUnsavedData = Object.assign({}, this.unsavedData, data);

        localStorage.setItem(nameSpace, JSON.stringify(mergedUnsavedData));

        this.setOnBeforeUnload(nameSpace);
    }
};



// WEBPACK FOOTER //
// ./components/edu-unsaved-data-observer/scripts/edu-unsaved-data-observer.js